<template>
  <div v-if="popularList.length" class="article-block">
    <div class="title-wrap">
      <h3>品牌趨勢文章</h3>
      <a :href="'/mag/' + brandCode">查看全部</a>
    </div>
    <div class="article-wrap">
      <div v-for="article in popularList" :key="article.ID" class="article">
        <a :href="'/mag/article/' + article.ID">
          <img class="img-fluid" :src="article.CoverImage" alt="TREND List" />
        </a>
        <div class="title">{{ article.Title }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

const { getArticleListAPI } = useAxiosAPI();

const dataIsLoad = ref(false);
const popularList = ref([]);
const brandCode = window.BrandCode;

getTrendList();

function getTrendList() {
  dataIsLoad.value = false;

  getArticleListAPI({
    params: { Category: 'ALL', Limit: 2, Page: 1, Content: 1, Tag: brandCode },
  })
    .then((res) => {
      if (res.data.Code === 200) {
        popularList.value = res.data.Response.Data;
        dataIsLoad.value = true;
      }
    })
    .catch((error) => {
      console.log(error);
    });
}
</script>
